module.exports = __webpack_public_path__ + "static/finance-70f454954b36e3c1c00433fce7751319.png";